module.exports = __webpack_public_path__ + "img/149.7ade5524.jpg";